import React from 'react';
import { Field } from 'redux-form';
import { Button } from '../index';
import './PaymentOptions.scss';

const PaymentButton = ({
  type,
  className,
  onPaymentChange,
  label,
  isSelected,
  hasError,
}) => {
  // const hasError = meta.error && meta.submitFailed;
  const classNames = ['payment-button', 'pad-right', className];
  if (hasError) {
    classNames.push('error');
  }
  if (isSelected) {
    classNames.push('buttonSelected');
  }

  const handlePaymentSelect = () => {
    onPaymentChange(type);
  };

  return (
    <Button
      id={`${label}-payment-button`.toLowerCase()}
      className={classNames.join(' ')}
      handleClick={handlePaymentSelect}
      label={<div className="payment-type-label"> {label} </div>}
    />
  );
};

const PaymentButtons = ({ input, paymentOptions, meta }) => {
  const hasError = meta.error && meta.submitFailed;
  const handlePaymentChange = (value) => {
    input.onChange(value);
  };

  return (
    <>
      {paymentOptions.map((paymentOption) => (
        <PaymentButton
          key={paymentOption.type}
          type={paymentOption.type}
          onPaymentChange={handlePaymentChange}
          label={paymentOption.label}
          isSelected={input.value === paymentOption.type}
          hasError={hasError}
        />
      ))}
      <span className={'input-error payment-options-buttons--error-msg'}>
        {hasError && meta.error}
      </span>
    </>
  );
};

const PaymentOptions = ({ paymentOptions, validate }) => {
  return (
    <div className="payment-options-buttons">
      <Field
        name={'meta.payment_type'}
        component={PaymentButtons}
        validate={validate}
        paymentOptions={paymentOptions}
      />
    </div>
  );
};

export default PaymentOptions;
